const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getDeliveryConfigs(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.programId) params.append('programId', filters.programId);
  if (filters.profileId) params.append('profileId', filters.profileId);
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/deliveries/sftp${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch delivery configs');
  }
  
  const data = await response.json();
  return data.configs;
}

export async function getDeliveryConfig(orgId, configId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/deliveries/sftp/${configId}`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch delivery config');
  }
  
  const data = await response.json();
  return data.config;
}

export async function createDeliveryConfig(orgId, data) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/deliveries/sftp`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(data)
  });
  
  if (!response.ok) {
    throw new Error('Failed to create delivery config');
  }
  
  const result = await response.json();
  return result.config;
}

export async function updateDeliveryConfig(orgId, configId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/deliveries/sftp/${configId}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    throw new Error('Failed to update delivery config');
  }
  
  const result = await response.json();
  return result.config;
}

export async function deleteDeliveryConfig(orgId, configId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/deliveries/sftp/${configId}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to delete delivery config');
  }
  
  return true;
}

export async function testDeliveryConfig(orgId, configId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/deliveries/sftp/${configId}/test`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to test delivery config');
  }
  
  return response.json();
}

export async function getDeliveryLogs(orgId, filters = {}) {
  const params = new URLSearchParams();
  if (filters.configId) params.append('configId', filters.configId);
  if (filters.status) params.append('status', filters.status);
  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (filters.limit) params.append('limit', filters.limit.toString());
  
  const queryString = params.toString();
  const url = `${API_BASE}/orgs/${orgId}/deliveries/logs${queryString ? '?' + queryString : ''}`;
  
  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch delivery logs');
  }
  
  const data = await response.json();
  return data.logs;
}
